import type { EndChatSessionBody } from "../types/chat.types";

export async function endChatSessionService(
  body: EndChatSessionBody,
  refreshToken?: () => Promise<string>,
  _retryCount: number = 0,
) {
  const apiUrl = import.meta.env.VITE_API_URL;
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (body.accessToken) {
    headers["Authorization"] = `Bearer ${body.accessToken}`;
  }

  try {
    const fullUrl = `${apiUrl}/logout`;
    const response = await fetch(fullUrl, {
      method: "POST",
      headers,
      credentials: "include",
    });

    if (!response.ok) {
      // Retry once if 401 Unauthorized
      if (response.status === 401 && refreshToken && _retryCount < 1) {
        try {
          const newAccessToken = await refreshToken();
          return endChatSessionService(
            {
              ...body,
              accessToken: newAccessToken,
            },
            refreshToken,
            _retryCount + 1,
          );
        } catch (error) {
          console.error("Failed to refresh token:", error);
          throw error;
        }
      }
      const errorText = await response.text();
      console.error(
        `API error during session end: ${response.status}: ${response.statusText}\n${errorText}`,
      );
    }
  } catch (error) {
    console.error("Failed to call end-session endpoint:", error);
  }
}
